/* import __COLOCATED_TEMPLATE__ from './noise-tab-panel.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed } from '@ember/object';

export default class NoiseTabPanel extends Component {
    tagName = '';

    @service('data') model;
    @service selectionData;
    @service errorHandling;
    @service componentManager;

    type = null;
    title = null;
    modalBodyArgs = {};

    @computed('type') get chartId() {
        return `${this.type}Chart`;
    }
}
